import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { getList, addData } from "../../helpers/fackBackend_Helper";
// CREATE USER
function* createUserResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, "/API/V1/User/CreateUser", data );
        if (response?.statusCode === 1200) {
            yield put(actions.createUserSuccess(response?.message));
        } else {
            yield put(actions.createUserError(response?.message || "Failed to create user"));
        }
    } catch (error) {
        yield put(actions.createUserError(error?.message || error)
        );
    }
}
// GET ASSIGNABLE ROLES
function* getAssignableRolesResponse() {
    try {
        const response = yield call(getList, "/API/V1/User/GetAssignableRoles");

        if (response?.statusCode === 1200) {
            yield put(actions.getAssignableRolesSuccess(response?.data || [])
            );
        } else {
            yield put(actions.getAssignableRolesError(response?.message || "Failed to get roles"));
        }
    } catch (error) {
        yield put(actions.getAssignableRolesError(error?.message || error));
    }
}

// GET USER LIST
function* getUserListResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, "/API/V1/User/GetUserList", data);
        if (response?.statusCode === 1200) {
            yield put(actions.getUserListSuccess(response?.data || []));
        } else {
            yield put(actions.getUserListError(response?.message || "Failed to get user list"));
        }
    } catch (error) {
        yield put(actions.getUserListError(error?.message || error));
    }
}
// MODIFY USER
function* modifyUserResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, "/API/V1/User/ModifyUser", data);
        if (response?.statusCode === 1200) {
            yield put(actions.modifyUserSuccess(response?.message));
        } else {
            yield put(actions.modifyUserError(response?.message || "Failed to modify user"));
        }
    } catch (error) {
        yield put(actions.modifyUserError(error?.message || error));
    }
}
// ROOT SAGA
export default function* rootSaga() {
    yield all([
        takeEvery(actions.CREATE_USER, createUserResponse),
        takeEvery(actions.GET_ASSIGNABLE_ROLES, getAssignableRolesResponse),
        takeEvery(actions.GET_USER_LIST, getUserListResponse),
        takeEvery(actions.MODIFY_USER, modifyUserResponse),
    ]);
}